import React from 'react'
import { css, cx } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { CsWebIcon } from '../../legacy-design-system/icons'
import {
  drilldownHeaderCss,
  readOnlyGridCss
} from '../../legacy-design-system/text'

const iconSize = 35
interface EmptyStateColumnProps {
  readonly title: string
  readonly description: string
}

export function EmptyStateColumn({
  title,
  description
}: EmptyStateColumnProps) {
  return (
    <div
      className={css`
        display: flex;
        flex: 1;
        flex-direction: column;
        align-items: center;
        width: fit-content;
      `}
    >
      <CsWebIcon color={theme.color.neutral50} size={iconSize} />
      <div
        className={cx(
          drilldownHeaderCss,
          css`
            margin-top: 5px;
          `
        )}
      >
        {title}
      </div>
      <div
        className={cx(
          readOnlyGridCss,
          css`
            min-width: 165px;
            text-align: center;
          `
        )}
      >
        {description}
      </div>
    </div>
  )
}
